import React from 'react';
import './TechSection.css';

function TechSection() {
  return (
    <div className='tech-container'>
      <div className='tech-content'>
        <div className='tech-image'>
          <img src='images/man1.png' alt='Server Image' />
        </div>

        <div className='tech-list'>
          <h1>Our Technology</h1>

          <ul className='tech-ul'>
            <li>
              Cloud-based Solution Development
              <ul>
                <li>Azure</li>
                <li>AWS</li>
                <li>Bedrock</li>
                <li>OpenAI</li>
              </ul>
            </li>
            <li>
              Advanced Data Extraction, Transformation, and Loading
              <ul>
                <li>Loading data from CSV, Text, Microsoft Excel, Microsoft Word, Facebook, Twitter, Google Search, Wikipedia</li>
                <li>Databases</li>
                <li>SQL Server</li>
                <li>MySQL</li>
                <li>MongoDB</li>
              </ul>
            </li>
            <li>
              Classical Machine Learning
              <ul>
                <li>Classification</li>
                <li>Clustering</li>
                <li>Anomaly Detection</li>
                <li>Time Series Analysis</li>
                <li>Market Basket Analysis</li>
                <li>Data Engineering</li>
                <li>Data Analytics</li>
              </ul>
            </li>
            <li>
              Deep Learning
              <ul>
                <li>Computer Vision</li>
                <li>Natural Language Processing</li>
                <li>Time Series Forecasting</li>
                <li>PyTorch</li>
                <li>OpenAI</li>
                <li>Hugging Face</li>
              </ul>
            </li>
            <li>
              Data Visualization
              <ul>
                <li>Tableau</li>
                <li>Power BI</li>
                <li>Plotly</li>
                <li>Interactive Maps</li>
                <li>Interactive HTML</li>
              </ul>
            </li>
            <li>
              Python Web Development for Data Science
              <ul>
                <li>FastAPI</li>
                <li>Django</li>
                <li>Django REST Framework</li>
                <li>PyTorch</li>
              </ul>
            </li>
            <li>
              Frontend Development
              <ul>
                <li>React</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default TechSection;
